import React,{Component} from 'react';
import Button from 'material-ui/Button';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import ExpansionPanel, {
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';
import { getJSON } from 'jquery'
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import Cookies from 'js-cookie'



class NovelCard extends Component{

    constructor(props){
        super(props);
        this.state={
            contextArray:[],
            load:false,
            login:this.isLogin()
        }

    }

    isLogin(){
        if (Cookies.get('user')==null){
            return false
        }else{

            return true
        }
    }


    componentWillMount(){
       this.handleUpdate();
    }

    handleUpdate(){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/getContexts',{id:this.props.novel.novelId}).then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.setState({
                    contextArray:data
                })

            }else {
                this.handleLoginError();

            }
            return true;
        },error=> {
        }).then(flag=>{
            this.setState({
                load:false
            })
        })
    }
    handleDelete(id,event){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121/newBlog/api/deleteContext',{id:id}).then(response=>{
            if (response.code>=1){


            }else {
                this.handleLoginError();

            }
            return true;
        },error=> {
        }).then(flag=>{
        this.handleUpdate();
        })
    }
    handleView(id){
        this.props.handleContext(id)

    }
    handleDeleteNovel(id,event){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/deleteNovel',{id:id}).then(response=>{
            if (response.code>=1){

                console.log("删除novel成功")
            }else {
                this.handleLoginError();
                console.log("删除novel失败")
            }
            return true;
        },error=> {
        }).then(flag=>{
            this.props.handleUpdate();
        })
    }


    render(){
        if (this.state.load){
            return (<table valign="medium" align="center" style={{width:'100%'}}>
                <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
                </td></tr></tbody></table>)
        }


        return(
            <div style={{marginBottom:'20px'}}>
                <ExpansionPanel style={{background:'#F8F8F8'}}>
                    <ExpansionPanelSummary expandIcon={
                        <Button style={{backgroundColor:'#fffdf4',height:'30px',width:'37px'}} variant="fab" aria-label="edit" >
                        <i className="material-icons">compare_arrows</i>
                    </Button>}>

                        <img src={'image/novel/'+this.props.novel.novelImage+'.jpg'} height={'100px'}/>

                            <h3 style={{marginLeft:'10px',fontWeight:'lighter'}}>{this.props.novel.novelTitle}</h3>


                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Divider/>

                        <Grid  container spacing={24}>
                            <Grid item xs={12} sm={12}>
                                <p style={{marginLeft:'10px',fontSize:'12px',textIndent:'2em'}}>
                                    {this.state.login?
                                    <Button size="small"  color="primary" onClick={this.handleDeleteNovel.bind(this,this.props.novel.novelId)} style={{cssFloat:'right'}}>
                                        DELETE
                                    </Button>
                                        :''}
                                    {this.props.novel.novelSignal}</p>
                            </Grid>
                        {this.state.contextArray.map((context)=>{
                            return(
                                <Grid key={context.contextId} item xs={12} sm={6}>
                                <Paper style={{width:'100%',textAlign:'center',background:'white'}}>
                                    {context.contextTitle} <span style={{color:'green',fontSize:'10px'}}>{context.contextTime.substring(0,10)}</span>
                                    <div>
                                    <Button size="small" onClick={this.handleView.bind(this,context.contextId)} color="primary" >
                                        VIEW
                                    </Button>
                                        {this.state.login?
                                    <Button size="small" onClick={this.handleDelete.bind(this,context.contextId)} color="primary" >
                                        DELETE
                                    </Button>
                                            :''}
                                    </div>
                                </Paper>
                                </Grid>
                            )}
                        )}
                        </Grid>

                    </ExpansionPanelDetails>
                </ExpansionPanel>

            </div>

        )
    }
}
export default NovelCard;


// WEBPACK FOOTER //
// ./src/Compent/page/NovelCard.js